import React from "react";
import { Container, Row, Col, Form, FormControl, Button, Card } from "react-bootstrap";
import { TIPOS_DOCUMENTO_TEXTO } from "constants/tiposDocumento";

const ContainerCheckDocsBDS3DesdeHasta = ({
  showTitle,
  lastcheck,
  tipodocumento,
  startDate,
  endDate,
  handleChangeTipoDocumento,
  HandleChaangeStartDate,
  HandleChaangeEndDate,
  busqueda,
  handleClean,
}) => {
  return (
    <Container fluid className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">{showTitle}</h2>
          <p className="page-subtitle">
            Compara documentos BD vs S3 en un rango de fechas.
            {lastcheck ? ` · Última actualización: ${lastcheck}` : ''}
          </p>
        </div>
      </div>

      <Card className="data-card">
        <Card.Body>
          <Form onSubmit={busqueda} className="filter-form">
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="form-field">
                  <Form.Label>Tipo documento</Form.Label>
                  <FormControl as="select" value={tipodocumento} onChange={handleChangeTipoDocumento}>
                    {TIPOS_DOCUMENTO_TEXTO.map((tipo) => (
                      <option key={tipo.value} value={tipo.value}>{tipo.label}</option>
                    ))}
                    <option value="0">Todos los tipos</option>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Desde</Form.Label>
                  <FormControl type="date" value={startDate} onChange={HandleChaangeStartDate} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Hasta</Form.Label>
                  <FormControl type="date" value={endDate} onChange={HandleChaangeEndDate} />
                </Form.Group>
              </Col>
              <Col xs={12} lg={2} className="d-flex align-items-end form-actions">
                <Button type="submit" className="btn-primary-action">
                  <i className="nc-icon nc-zoom-split" />
                  Buscar
                </Button>
              </Col>
            </Row>
            <div className="filter-form__footer">
              <Button className="btn-link-clear" onClick={handleClean}>
                Limpiar filtros
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContainerCheckDocsBDS3DesdeHasta;
